<template>
  <a
    class="btn btn-sm btn-link tooltip tooltip-top mx-2"
    v-if="!hide && kind !== 'small'"
    :href="path"
    data-tooltip="MATPOWER User's Manual"
    aria-label="MATPOWER User's Manual"
  >
    <help-circle-icon />
  </a>
  <a
    class="tooltip tooltip-top small-button"
    v-else-if="!hide"
    :href="path"
    data-tooltip="MATPOWER User's Manual"
    aria-label="MATPOWER User's Manual"
  >
    <sup>?</sup>
  </a>
</template>

<script>
import { HelpCircleIcon } from "vue-feather-icons";

import { HTMLPaths, PDFPaths, pdfPath } from "../paths";
import ConfigStore from "../stores/ConfigStore";

export default {
  name: "HelpButton",
  props: ["section", "kind"],
  computed: {
    hide() {
      return ConfigStore.methods.getManual() === "hide";
    },
    path() {
      let manual = ConfigStore.methods.getManual();
      let paths = manual === "html" ? HTMLPaths : PDFPaths;
      let name = this.section + "Path";
      if (paths.hasOwnProperty(name)) {
        return paths[name];
      }
      return pdfPath;
    }
  },
  components: { HelpCircleIcon }
};
</script>
